module.exports = __webpack_public_path__ + "13a061ea7f526a9e20fd2a8e26d4223c.woff";